import axios from 'axios';
import {generateCorrelationId, correlationIdHeaderName} from 'utils/telemetry';
import handleApiError from './handleApiError';

const domain = window.location.origin || '';

/* API */
const map = new Map();

export default async function api(method, url, params, data, key) {
	const headers = {
		[correlationIdHeaderName]: generateCorrelationId(),
	};
	const axiosParams = {...params};
	let signal;
	let controller;

	// Assign an AbortController
	// -> Is there a key and feature detection for AbortController pass?
	// -> abort() a previous controller by the same key if it exists
	// -> Create a new controller, store it and capture the signal to pass to axios
	if (key && typeof AbortController === 'function') {
		const prevController = map.get(key);
		if (prevController) {
			// cancel the previous request
			prevController.abort();
		}

		// Create an Abort Controller Instance
		controller = new AbortController();
		signal = controller.signal;
		map.set(key, controller);
	}

	if (method === 'cache') {
		// Set this back to a get
		method = 'get';
		headers['Cache-Control'] = 'public, max-age=86400';
	} else {
		// All other requests should be cache-busted
		axiosParams.rand = Date.now();
	}

	try {
		const {data: body} = await axios({
			method,
			url: domain + url,
			params: axiosParams,
			headers,
			data,
			signal,
		});

		return body;
	} catch (err) {
		// If there is no response
		// i.e. Error('canceled');
		// -> Throw error
		if (!err.response) {
			throw err;
		}

		const {data, status, headers} = err.response;

		// If the data is a string, aka gateway issues
		const respObject = typeof data === 'object' ? data : {text: data};

		// Put this into the error body
		if (headers?.['retry-after']) {
			respObject.retry_after = headers['retry-after'];
		}

		// Restructure legacy message objects
		// @todo: refactor legacy error objects in the api
		respObject.message ??= respObject.error;

		const errorObj = handleApiError({...respObject, status});
		if (errorObj) {
			throw errorObj;
		}
	} finally {
		// Remove any controller reference
		// -> Do we even have a controller and key?
		// -> Is the controller the same as what is currently stored?
		// -> Ok, delete it from the store.
		if (key && controller) {
			const currentController = map.get(key);
			if (controller === currentController) {
				map.delete(key);
			}
		}
	}
}
